import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import logoUrl from '../lendnation-logo-v2.svg';

class Logo extends Component {
  render() {
    return (
      <footer className="apply-now-footer">
        <Row>
          <Col lg="3" sm="4" xs="6">
            <img
              src={logoUrl}
              alt="CashMax"
              className="img-responsive logo-img"
            />
          </Col>
          <Col lg="9" sm="4" xs="12">
            <small>
              <br />
              Customer Notice: There are a wide variety of financial
              products available in the marketplace, so your choice of
              such products should match your financial needs.
              Short-term, small dollar credit used over a long period
              of time can be expensive. Certain restrictions may
              apply, including state database and credit underwriting
              standards and limitations. Visit a LendNation store or
              contact us for details.
            </small>
          </Col>
        </Row>
      </footer>
    );
  }
}
export default Logo;
